import React from 'react';
import { DialogContent, DialogContentProps } from '@material-ui/core';

export const MainDialogContent = (props: DialogContentProps) => {
  return <DialogContent dividers {...props} />;
};
